import { render } from "./list.vue?vue&type=template&id=594da9b7"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"

import "./list.vue?vue&type=style&index=0&id=594da9b7&lang=css"
script.render = render

export default script